export default __webpack_public_path__ + "static/media/b56.6082a0c9.png";